import { Component, OnInit } from '@angular/core';
import { TableService } from '../../services/table.service';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { Knowledge } from '../../models/enum/knowledge.enum';
import { Like } from '../../models/enum/like.enum';
import { Teaching } from '../../models/enum/teaching.enum';
import { Tooltip } from 'primeng/tooltip';
import { CommonModule, NgStyle } from '@angular/common';
import { YearlySkillsDto } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-detail-table',
  standalone: true,
  imports: [
    TableModule,
    MultiSelectModule,
    FormsModule,
    Tooltip,
    NgStyle,
    CommonModule,
  ],
  templateUrl: './user-detail-table.component.html',
  styleUrls: ['./user-detail-table.component.scss'],
})
export class UserDetailTableComponent implements OnInit {
  skills: string[] = [];
  skillsCategory: string[] = [];

  levels: string[] = ['knowledge', 'like', 'teach', 'student'];
  selectedLevels: string[] = [];

  teams: string[] = [];
  selectedTeams: string[] = [];

  data: YearlySkillsDto[] = [];
  filteredData: YearlySkillsDto[] = [];

  knowledge = Knowledge;
  like = Like;
  teach = Teaching;

  groups: string[] = [];
  filteredSkillGroup: string[] = [];
  selectedSkillGroup: string[] = [];

  skillsWithGroup: { skillName: string; groupName: string }[] = [];

  constructor(
    private tableService: TableService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const id = params['userId'];
      if (id) {
        this.tableService.getSkills().subscribe(skills => {
          this.skills = skills.map(skill => skill.skill_name);
          this.skillsCategory = this.skills;
          this.groups = [...new Set(skills.map(skill => skill.g_name))];
          this.skillsWithGroup = skills.map(skill => ({
            skillName: skill.skill_name,
            groupName: skill.g_name,
          }));
        });

        this.tableService.getUserSkillsByYear(id).subscribe(data => {
          this.data = data;
          this.filteredData = [...data];
          console.log(this.data);
        });
      }
    });



  }

  severityLevel(
    data: number,
    type: string
  ):
    | 'info'
    | 'success'
    | 'warn'
    | 'danger'
    | 'secondary'
    | 'contrast'
    | 'help'
    | 'primary' {
    if (data || data === 0) {
      switch (type) {
        case 'like':
        case 'knowledge':
          return data === 1 ? 'success' : data === 2 ? 'warn' : 'danger';
        case 'teaching_learning':
          return data === 0 ? 'success' : 'info';
        default:
          return 'secondary';
      }
    }
    return 'secondary';
  }

  getInitials(name: string): string {
    if (!name) return '';

    const parts = name.split(' ');
    const initials = (parts[0]?.charAt(0) || '') + (parts[1]?.charAt(0) || '');

    return initials.toUpperCase();
  }

  getIcon(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const icons: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'fa-check',
        '2': 'fa-xmark',
        '3': 'fa-minus',
      },
      like: {
        '1': 'fa-check',
        '2': 'fa-xmark',
        '3': 'fa-minus',
      },
      teaching_learning: {
        '0': 'fa-person-chalkboard',
        '1': 'fa-graduation-cap',
        '2': 'fa-minus',
      },
    };

    return icons[category]?.[String(value)] || 'fa-solid fa-minus';
  }

  getColor(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const colors: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'p-badge-success',
        '2': 'p-badge-error',
        '3': 'p-badge-undefined',
      },
      like: {
        '1': 'p-badge-success',
        '2': 'p-badge-error',
        '3': 'p-badge-undefined',
      },
      teaching_learning: {
        '0': 'p-badge-info',
        '1': 'p-badge-info',
        '2': 'p-badge-undefined',
      },
    };

    return colors[category]?.[String(value)] || 'p-badge-undefined';
  }

  getTooltipLabel(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const colors: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'Conosco',
        '2': 'Non conosco',
        '3': 'Non lo so',
      },
      like: {
        '1': 'Interessato',
        '2': 'Non interessato',
        '3': 'Non lo so',
      },
      teaching_learning: {
        '0': 'Disponibile come mentore',
        '1': 'Desideroso di imparare',
        '2': 'Indifferente',
      },
    };
    return colors[category]?.[String(value)] || 'Non definito';
  }
}
